import React, {useEffect} from 'react';
import '../../styles/application/Snackbar.scss';
import CheckCircleTwoTone from '@mui/icons-material/CheckCircleTwoTone';
import {useTransition, animated} from 'react-spring';
import {useDispatch, useSelector} from 'react-redux';
import {
  removeSlideIn,
  selectSnack,
  selectSnackMsg,
} from '../../app/redux/snackSlice';

function Snackbar() {
  const snack = useSelector(selectSnack);
  const snackMsg = useSelector(selectSnackMsg);

  const dispatch = useDispatch();

  const snackIn = {
    transform: 'translate3d(0, 0, 0)',
  };

  const snackOut = {
    transform: 'translate3d(250px, 0, 0)',
  };

  const transitions = useTransition(snack, null, {
    from: snackOut,
    enter: snackIn,
    leave: snackOut,
  });

  useEffect(() => {
    if (snack) {
      const interval = setInterval(() => {
        dispatch(removeSlideIn());
      }, 2000);

      return () => clearInterval(interval);
    }
  }, [snack, snackMsg, dispatch]);

  return (
    <>
      {transitions.map(({item, key, props}) =>
        item ? (
          <animated.div key={key} style={props} className="snackbar">
            <CheckCircleTwoTone
              style={{color: 'greenyellow'}}
              className="snackbar_icon"
            />
            <h4>{snackMsg}!</h4>
          </animated.div>
        ) : (
          <animated.div key={key}></animated.div>
        )
      )}
    </>
  );
}

export default Snackbar;
